exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-msg{\n    margin: 40px;\n}\n\n.empty-msg p{\n    color: #a3a3a3;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/last-offers/last-offers.component.css
// module id = ../../../../../src/app/pages/last-offers/last-offers.component.css
// module chunks = main